import React from "react";
import "../styles/pages.css";

const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <div className="legal-page">
        <h1 className="legal-title">Privacy Policy</h1>
        <div className="legal-content">
          <p className="legal-date">Last Updated: March 24, 2025</p>

          <section className="legal-section">
            <h2>1. Overview</h2>
            <p>
              PICKTECH ('we', 'us', 'our') takes your privacy very seriously.
              This Privacy Policy explains what information we collect, how we
              use that information, and your choices regarding your personal
              information.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Information We Collect</h2>
            <p>We may collect the following personal information:</p>
            <ul>
              <li>
                Contact information such as name, email address, and phone
                number
              </li>
              <li>
                Automatically generated data such as IP addresses and cookie
                data
              </li>
              <li>Usage information, access logs, and service usage records</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. How We Use Your Information</h2>
            <p>The information collected is used for the following purposes:</p>
            <ul>
              <li>Providing and operating our services</li>
              <li>Improving and developing new services</li>
              <li>User authentication and account management</li>
              <li>
                Responding to user inquiries and providing customer support
              </li>
              <li>Marketing and promotional activities (with your consent)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Information Security</h2>
            <p>
              We take appropriate technical and administrative measures to
              protect your personal information. Personal information is only
              disclosed to employees who need access, and we regularly update
              our security systems.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Third-Party Disclosure</h2>
            <p>
              We do not provide your personal information to third parties
              without your consent, except where required by law or necessary
              for service provision.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Cookies</h2>
            <p>
              Our website uses cookies to enhance user experience. You can
              refuse cookies through your browser settings, although this may
              limit some website functionality.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Your Rights</h2>
            <p>
              You have the following rights regarding your personal information:
            </p>
            <ul>
              <li>Access and request copies of your personal information</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your personal information</li>
              <li>
                Request restrictions on processing your personal information
              </li>
              <li>Withdraw consent to processing your personal information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Changes to This Privacy Policy</h2>
            <p>
              This Privacy Policy may be updated as needed, and significant
              changes will be communicated through website notices or email.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact Us</h2>
            <p>
              If you have questions or concerns about our privacy practices,
              please contact us at:
            </p>
            <p className="contact-info">
              Email: jacob.yu.webdev@gmail.com
              <br />
              Phone: +61 414 989 606
              <br />
              Address: Lidcombe, NSW, Australia
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
